import { Message } from "../models/Message";

/**
 * Merges freshly fetched messages into the loaded ones by id, newest first. A refresh
 * of the newest page must not drop older pages already scrolled back to.
 */
export const mergeMessages = (loaded: Message[], incoming: Message[]): Message[] => {
  const byId = new Map(loaded.map((message) => [message.id, message]));
  incoming.forEach((message) => byId.set(message.id, message));
  return [...byId.values()].sort(
    (a, b) => b.createdAt.getTime() - a.createdAt.getTime() || (a.id < b.id ? 1 : -1),
  );
};
